import { render } from "./CateringHeader.vue?vue&type=template&id=28eafae5"
import script from "./CateringHeader.vue?vue&type=script&lang=js"
export * from "./CateringHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__